/** Minúsculas y sin acentos: "Hernández" -> "hernandez". */
const fold = (value: string): string =>
  value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

/**
 * Búsqueda local por palabras: cada palabra de `search` debe aparecer en
 * alguno de `fields`, en cualquier orden y como coincidencia parcial. Ignora
 * mayúsculas, acentos y espacios extra; una búsqueda vacía coincide con todo.
 * Mismo criterio que la búsqueda del backend (`andWhereSearch`).
 */
export function matchesSearch(
  search: string | null | undefined,
  ...fields: Array<string | null | undefined>
): boolean {
  const terms = fold(search ?? '').split(/\s+/).filter(Boolean);
  if (terms.length === 0) return true;
  const haystack = fold(fields.filter(Boolean).join(' '));
  return terms.every((term) => haystack.includes(term));
}
